import { Check, UploadTwoTone } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Button, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { BottomAppBar } from '../../../../components/BottomAppBar';
import { PageHeader } from '../../../../components/PageHeader';
import { useSafeNavigation } from '../../../../hooks/useSafeNavigation';
import { PageContent, PageLayout } from '../../../../layout';
import { useConfirmInvoiceForm } from '../../../../modules/invoice/hooks/useConfirmInvoiceForm';
import { InvoiceFormModule } from '../../../../modules/invoice/InvoiceFormModule';
import { notify } from '../../../../utils/notification';

export const InvoiceConfirmDataPage = () => {
  const { invoiceId } = useParams();
  const { t } = useTranslation('page-check-invoice');
  const { safeNavigate } = useSafeNavigation();

  const {
    onFormSubmit,
    state: { isReady, isLoading },
  } = useConfirmInvoiceForm({
    onSuccess: (id) => safeNavigate(`/upload/invoice/${id}/billing`),
    onError: () => {
      notify.negative({
        title: t('error.mutation.title'),
        message: t('error.mutation.text'),
      });
    },
    onValidationError: () => {
      notify.negative({
        title: t('error.validation.title'),
        message: t('error.validation.text'),
      });
    },
  });

  return (
    <PageLayout>
      <Grid2 container spacing={{ xs: 2, md: 8 }}>
        <Grid2 xs={12} md={6}>
          <PageHeader title={t('title')} subtitle={t('subtitle')} sx={{ flexShrink: 0 }} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <Alert severity="info">
            <Typography variant={'body2'} fontWeight={'bold'}>
              {t('info.header')}
            </Typography>
            <Typography variant={'body2'}>{t('info.text')}</Typography>
          </Alert>
        </Grid2>
      </Grid2>
      <PageContent>
        {invoiceId ? (
          <InvoiceFormModule
            invoiceId={invoiceId}
            invoiceFormProps={{
              onSubmit: (data) => onFormSubmit(invoiceId, data),
              defaultValidated: true,
              formId: 'invoice-form',
              allowInvoiceItems: false,
            }}
          />
        ) : null}
      </PageContent>
      <BottomAppBar>
        <Button
          component={Link}
          to={'/upload'}
          variant={'outlined'}
          startIcon={<UploadTwoTone />}
          sx={{ bgcolor: 'background.paper' }}
        >
          {t('action.back')}
        </Button>
        <LoadingButton
          loading={isLoading}
          disabled={!isReady}
          type={'submit'}
          form={'invoice-form'}
          variant={'contained'}
          size={'large'}
          startIcon={<Check />}
        >
          {t('action.confirm')}
        </LoadingButton>
      </BottomAppBar>
    </PageLayout>
  );
};
